import { FC } from "react";
import { ICellRendererParams } from "ag-grid-community";
import { SnowflakeConnection } from "@/services/cloudchipr.api";
import { formatDate } from "@/utils/helpers/date-time/datetime-format";
import { TypographyWithTooltip } from "@/components/common/TypographyWithTooltip";

export const SnowflakeConnectionLastCollectedCellRenderer: FC<
  ICellRendererParams<SnowflakeConnection>
> = ({ data }) => {
  const date = data?.last_collected;

  if (!date) {
    return "-";
  }

  return (
    <TypographyWithTooltip
      title={` 
      ${formatDate(date, {
        type: "dateWithComma",
      })} 
      ${formatDate(date, {
        type: "time",
      })} (UTC)`}
      variant="body2"
      sx={{ whiteSpace: "nowrap" }}
    />
  );
};
